import { eventDetails } from "../data/content";
import "./Hero.css";

export default function Hero(): JSX.Element {
  return (
    <header className="hero">
      <img
        className="hero__image"
        src="/images/hero-lake.jpg"
        alt="Fanni és Marci a Balaton partján"
      />
      <div className="hero__overlay" aria-hidden="true" />
      <div className="hero__content container">
        <p className="hero__eyebrow">
          {eventDetails.date} · {eventDetails.region}
        </p>
        <h1 className="hero__title">
          Fanni <span>&amp;</span> Marci
        </h1>
        <p className="hero__subtitle">
          Szeretettel várunk benneteket esküvőnkre.
        </p>
        <div className="hero__actions">
          <a className="hero__cta" href="#schedule">
            A legfontosabb tudnivalók
          </a>
        </div>
      </div>
    </header>
  );
}
